/**
 * @generated SignedSource<<66d176c9e80f3b3892b227237b02d2b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSegmentsPage_screener$data = {
  readonly id: string;
  readonly segments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Segment_segment">;
      } | null;
    } | null>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Segment_screener">;
  readonly " $fragmentType": "ProjectSegmentsPage_screener";
};
export type ProjectSegmentsPage_screener$key = {
  readonly " $data"?: ProjectSegmentsPage_screener$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSegmentsPage_screener">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSegmentsPage_screener",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SegmentNodeConnection",
      "kind": "LinkedField",
      "name": "segments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SegmentNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SegmentNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Segment_segment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Segment_screener"
    }
  ],
  "type": "ScreenerNode",
  "abstractKey": null
};
})();

(node as any).hash = "774cf68549ca4d1a9abd22f4a2a12e35";

export default node;
